import { render, staticRenderFns } from "./index_pc.vue?vue&type=template&id=a751db1a&scoped=true"
import script from "./index_pc.vue?vue&type=script&lang=js"
export * from "./index_pc.vue?vue&type=script&lang=js"
import style0 from "./index_pc.scss?vue&type=style&index=0&id=a751db1a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a751db1a",
  null
  
)

export default component.exports